import { jsx } from 'react/jsx-runtime';

const prePageRouterCls = "_61p14e9l3m";
function PrePageRouterPlaceholder() {
  return /*#__PURE__*/jsx("div", {
    className: prePageRouterCls
  });
}

export { PrePageRouterPlaceholder, prePageRouterCls };
import "./pre-page-router.linaria.module.css";
//# sourceMappingURL=pre-page-router.js.map
